/**
 * GET-ARCHIVE-QUESTION-ITEM
 * Match one item of a "scale" battery question (options.multipleItems) with the archive database
 * An item is archived as a scale question of its own (proposition.questionAid, see
 * survey.application getTemplate), so its results are a regular row of /questions
 */

import { Proposition } from "@/redux/proposition.types"
import { Topic } from "@/redux/topic.types"

const getArchiveQuestionItem = (topic: Topic, proposition: Proposition, archiveQuestions: any[]) => {
  const archiveQuestionItem = archiveQuestions.find(
    (x) => x.aid === proposition.questionAid && x.fkTopic === topic.aid
  )

  if (archiveQuestionItem) {
    proposition.repartition = archiveQuestionItem.repartition ? archiveQuestionItem.repartition : []
    proposition.noAnswers = archiveQuestionItem.noAnswers
  } else {
    proposition.repartition = []
    proposition.noAnswers = 0
  }

  return proposition
}

export default getArchiveQuestionItem
